import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=63ddf71d&"
import script from "./Inbox.vue?vue&type=script&lang=js&"
export * from "./Inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ddf71d')) {
      api.createRecord('63ddf71d', component.options)
    } else {
      api.reload('63ddf71d', component.options)
    }
    module.hot.accept("./Inbox.vue?vue&type=template&id=63ddf71d&", function () {
      api.rerender('63ddf71d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Messages/Inbox.vue"
export default component.exports